module.exports = __webpack_public_path__ + "img/logo2.f77ded10.gif";